import { useEffect, useState } from 'react';
/** Phone widths, below Tailwind's `sm` breakpoint (640px). */
export const COMPACT_VIEWPORT_QUERY = '(max-width: 639px)';
const viewportMatches = () => typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(COMPACT_VIEWPORT_QUERY).matches;
/**
 * True when the viewport is phone-sized (below Tailwind's `sm` breakpoint).
 * Select and Dropdown use this to present their options as a bottom sheet.
 */
export const useCompactViewport = () => {
    const [isCompact, setIsCompact] = useState(viewportMatches);
    useEffect(() => {
        if (typeof window.matchMedia !== 'function') {
            return;
        }
        const media = window.matchMedia(COMPACT_VIEWPORT_QUERY);
        const update = () => setIsCompact(media.matches);
        update();
        media.addEventListener('change', update);
        return () => media.removeEventListener('change', update);
    }, []);
    return isCompact;
};
//# sourceMappingURL=use_compact_viewport.hook.js.map